forms-users-save  
  form.form(action="{ opts.action }" method="{ opts.method }" onSubmit="{ this.onSubmit }")
    inputs-hidden(tag-scope="{ this.tagScope }.inputs.method")
    inputs-hidden(tag-scope="{ this.tagScope }.inputs.authenticity_token")
    inputs-textfield(tag-scope="{ this.tagScope }.inputs.name")
    inputs-textfield(tag-scope="{ this.tagScope }.inputs.name_alt")
    inputs-textfield(tag-scope="{ this.tagScope }.inputs.email")
    inputs-password(tag-scope="{ this.tagScope }.inputs.password")
    inputs-password(tag-scope="{ this.tagScope }.inputs.password_confirmation")
    inputs-checkbox-multiple(tag-scope="{ this.tagScope }.inputs.role")
    inputs-checkbox-select.inside_teams(tag-scope="{ this.tagScope }.inputs.inside_teams")
    inputs-checkbox-select.outside_teams(tag-scope="{ this.tagScope }.inputs.outside_teams")
    inputs-submit(tag-scope="{ this.tagScope }.inputs.submit")
  script(type="typescript").
    this.mixin('forms.users.save')
